


/* eslint-disable*/
// import React from 'react';
// import styles from './AnnualTax.module.css';

// const AnnualTax = ({
//   amount = '1.2',
//   unit = 'Cr',
//   difference = '0.50',
//   isPositive = false,
//   tdsStatus = [
//     { form: 'Form 24Q', status: 'On Time' },
//     { form: 'Form 26Q', status: 'Delayed' }
//   ],
//   chartData = [
//     { label: 'Completed', value: 50 }, 
//     { label: 'Pending', value: 50 }
//   ],
// }) => {
//   const total = chartData.reduce((sum, item) => sum + item.value, 0);
//   let cumulativeAngle = 0;

//   const segments = chartData.map((item, index) => {
//     const percentage = (item.value / total) * 100;
//     const angle = (item.value / total) * 360;
//     const startAngle = cumulativeAngle;
//     const endAngle = cumulativeAngle + angle;
//     cumulativeAngle += angle;

//     const radius = 60;
//     const centerX = 80;
//     const centerY = 80;

//     const startAngleRad = (startAngle - 90) * (Math.PI / 180);
//     const endAngleRad = (endAngle - 90) * (Math.PI / 180);

//     const x1 = centerX + radius * Math.cos(startAngleRad);
//     const y1 = centerY + radius * Math.sin(startAngleRad);
//     const x2 = centerX + radius * Math.cos(endAngleRad);
//     const y2 = centerY + radius * Math.sin(endAngleRad);

//     const largeArcFlag = angle > 180 ? 1 : 0;

//     const pathData = [
//       `M ${centerX} ${centerY}`,
//       `L ${x1} ${y1}`,
//       `A ${radius} ${radius} 0 ${largeArcFlag} 1 ${x2} ${y2}`,
//       'Z'
//     ].join(' ');

//     const textAngle = (startAngle + endAngle) / 2;
//     const textAngleRad = (textAngle - 90) * (Math.PI / 180);
//     const textRadius = radius * 0.7;
//     const textX = centerX + textRadius * Math.cos(textAngleRad);
//     const textY = centerY + textRadius * Math.sin(textAngleRad);

//     return {
//       ...item,
//       pathData,
//       textX,
//       textY,
//       percentage: Math.round(percentage),
//       color: index === 0 ? '#0891b2' : '#d1d5db'
//     };
//   });

//   return (
//     <div className={styles.container}>
//       {/* Top Section */}
//       <div className={styles.topSection}>
//         <div className={styles.amount}>₹ {amount}</div>
//         <div className={styles.unit}>{unit}</div>
//         <div className={styles.diffContainer}>
//           <span>{isPositive ? '↑' : '↓'}</span>
//           <div>₹ {difference}{unit}</div>
//         </div>
//       </div>

//       {/* Main Section: Table + Pie */}
//       <div className={styles.mainSection}>
//         {/* Table Container */}
//         <div className={styles.tableContainer}>
//           <table className="table table-sm table-bordered w-100">
//             <thead className="table-light">
//               <tr>
//                 <th>TDS</th>
//                 <th>Status</th>
//               </tr>
//             </thead>
//             <tbody>
//               {tdsStatus.map((row, idx) => (
//                 <tr key={idx}>
//                  <td className={styles.tdsBlue}>{row.form}</td>
//       <td className={row.status === 'On Time' ? styles.tdsGreen : styles.tdsOrange}>
//                     {row.status}
//                   </td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </div>

//         {/* Pie Chart Container */}
//         <div className={styles.pieChartContainer}>
//           <svg width="120" height="120" viewBox="0 0 160 160">
//             {segments.map((segment, index) => (
//               <g key={index}>
//                 <path
//                   d={segment.pathData}
//                   fill={segment.color}
//                   stroke="#ffffff"
//                   strokeWidth="2"
//                 />
//                 <text
//                   x={segment.textX}
//                   y={segment.textY}
//                   textAnchor="middle"
//                   dominantBaseline="middle"
//                   fontSize="12"
//                   fontWeight="bold"
//                   fill="#000"
//                 >
//                   {segment.percentage}%
//                 </text>
//               </g>
//             ))}
//           </svg>

//           {/* Legend */}
//           <div className={styles.legend}>
//             {segments.map((segment, index) => (
//               <div key={index} className={styles.legendItem}>
//                 <div
//                   className={styles.dot}
//                   style={{ backgroundColor: segment.color }}
//                 ></div>
//                 <span>{segment.label}</span>
//               </div>
//             ))}
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default AnnualTax;

// #############################################

import React from 'react';

const AnnualTax = ({data}) => {
  // Data is often passed via props in a real-world scenario, but we define it here for simplicity
  // const data = [
  //   { tds: 'Form 24Q', status: 'Delayed' },
  //   { tds: 'Form 26Q', status: 'On Time' },
  // ];

  // Convert CSS styles to React's inline style object (camelCase)
  const tableStyle = {
    // marginTop:'10px',
    marginBottom: '20px',
    marginLeft: '20px',
    maxHeight: '200px',
    borderCollapse: 'collapse',
    minWidth: '400px',
    textAlign: 'left',
    border: '1px solid #ccc'
  };

  const headerCellStyle = {
    padding: '8px',
    backgroundColor: '#f2f2f2',
    border: '1px solid #ccc',
    // position: 'sticky', // ✅ makes header fixed
    // top: 0,             // ✅ sticks to the top of scroll area
    // zIndex: 1,   
  };

  const dataCellStyle = {
    padding: '8px',
    border: '1px solid #ccc'
  };

  return (
    <table style={tableStyle}>
      <thead>
        <tr>
          <td style={{backgroundColor:'#e5e7eb',fontWeight: "bold"}}>TDS</td>
          <td  style={{backgroundColor:'#e5e7eb',fontWeight: "bold"}}>Status</td>
        </tr>
      </thead>
      <tbody>
        {data.map((row, index) => (
          <tr key={index}>
            <td style={dataCellStyle}>{row.tds}</td>
            <td style={dataCellStyle}>{row.status}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default AnnualTax;